import Constants from '../utils/consts';
import Utils from '../utils/utils';
import Cookies from 'universal-cookie';

var db = new Cookies().get('db', {path: '/' });
var http = require('follow-redirects').https;
var fs = require('fs');
var qs = require('querystring');


export default async function addEsame(uname, token, id_corso, id_insegnante, nome_insegnante, id_materia, data, titolo, type) {
    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': Constants.apisFolder + 'addEsame.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            const resp = JSON.parse(body.toString());
            resolve(resp);
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
        'token': token,
        'uname': uname,
        'id_corso': id_corso,
        'data': data,
        'id_insegnante': id_insegnante,
        'nome_insegnante': Utils.escapeString(nome_insegnante), 
        'id_materia': id_materia,
        'titolo': Utils.escapeString(titolo),
        'type': type,
        'db_name': db
        });

        req.write(postData);

        req.end();
        
    });
}
